const subDomainUrl = process.env.PUBLIC_URL.split("/");
const dev = {
    rootUrl: "http://localhost:8080/",
    web_mw: "https://ewuat.edelbusiness.in/EWMTrade/api/",
    streamUrl: "wss://ewstream.edelweiss.in/",
    jmwedel: "https://nmwuat1.nuvamawealth.com/",
    jmw: "https://nmwuat1.nuvamawealth.com/",
    jmw_reports: "https://nmwuat1.nuvamawealth.com/",
    jmw_content: "edelmw-content-uat/content/",
    jmw_news_content: "edelmw-spr-content-uat/",
    jmw_login: "edelmw-login-uat/login/",
    adminuat: "https://nmwuat1.nuvamawealth.com/",
    appId: "9e5481c0130b8bba8190e52bdc5038ba",
    oldWebUrl: "https://vamauat.nuvamawealth.com/",
    newWebUrl: "https://vamauat.nuvamawealth.com/",
    edisUrl: "https://vamauat.nuvamawealth.com/edis",
    epledgeUrl: "https://vamauat.nuvamawealth.com/epledge",
    unpledgeurl: "https://vamauat.nuvamawealth.com/epledge/?unpledge",
    reportBase: "",
    baseEnvironment: "dev/",
    feReportBase: "/reports",
    revamp: "revamp/",
    jmw_content_kambala: "edelmw-content-uat/content/",
    eqedel: "edelmw-eq-uat/eq/",
    commedel: "edelmw-comm-uat/comm/",
    equity: "edelmw-eq-uat/eq/",
    commodity: "edelmw-comm-uat/comm/",
    accOpeningUrl: "https://onboardinguat.nuvamawealth.com/",
    kambalaBase: "",
    kambalaSwitch: true,
    web_config_access_reports: "new-features/",
    jmw_market: "app-marketstats/",
    jmw_mf: "edelmw-mf-uat/mf/",
    jmw_eq: "edelmw-eq-uat/eq/",
    appClient: "app-client/",
    jmw_market_env: "",
    edelmw_sr: "edelmw-sr-uat",
    edelmw_nse: "edelmw-nse-uat/nse/",
    jmw_conten_no_revamp: "edelmw-content-uat/content/",
    appIdKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOjEsImZmIjoiVyIsImJkIjoid2ViLXBjIiwibmJmIjoxNjQ2MjAzNTAzLCJzcmMiOiJlbXRtdyIsImF2IjoiMS4wLjAuNCIsImFwcGlkIjoiNjYzMDUxY2ZiYWM3ZDY5OWExYzU5Yjk2MDQ4YjUwZTciLCJpc3MiOiJlbXQiLCJleHAiOjE2NDYyNDU4MDAsImlhdCI6MTY0NjIwMzgwM30.VCTEFN-PGmGoxUpUElRskqXEkqlvtJ43CbdUlCX1HmQ",
};
const uat = {
    rootUrl: "https://vamauat.nuvamawealth.com/" + "revamp/",
    web_mw: "https://nwmwuat.nuvamawealth.com/EWMTrade/api/",
    streamUrl: "wss://ewstream.edelweiss.in/",
    jmwedel: "https://nmwuat1.nuvamawealth.com/",
    jmw: "https://nmwuat1.nuvamawealth.com/",
    jmw_reports: "https://nmwuat1.nuvamawealth.com/",
    jmw_content: "edelmw-content-uat/content/",
    jmw_news_content: "edelmw-spr-content-uat/",
    jmw_login: "edelmw-login-uat/login/",
    adminuat: "https://nmwuat1.nuvamawealth.com/",
    appId: "9e5481c0130b8bba8190e52bdc5038ba",
    oldWebUrl: "https://vamauat.nuvamawealth.com/",
    newWebUrl: "https://vamauat.nuvamawealth.com/bucket1",
    edisUrl: "https://vamauat.nuvamawealth.com/edis",
    epledgeUrl: "https://vamauat.nuvamawealth.com/epledge",
    unpledgeurl: "https://vamauat.nuvamawealth.com/epledge/?unpledge",
    reportBase: "",
    baseEnvironment: "dev/",
    feReportBase: "/reports",
    revamp: "revamp/",
    jmw_content_kambala: "edelmw-content-uat/content/",
    eqedel: "edelmw-eq-uat/eq/",
    commedel: "edelmw-comm-uat/comm/",
    equity: "edelmw-eq-uat/eq/",
    commodity: "edelmw-comm-uat/comm/",
    accOpeningUrl: "https://onboardinguat.nuvamawealth.com/",
    kambalaBase: "",
    kambalaSwitch: true,
    web_config_access_reports: "new-features/",
    jmw_market: "app-marketstats/",
    jmw_mf: "edelmw-mf-uat/mf/",
    jmw_eq: "edelmw-eq-uat/eq/",
    appClient: "app-client/",
    jmw_market_env: "",
    edelmw_sr: "edelmw-sr-uat",
    edelmw_nse: "edelmw-nse-uat/nse/",
    jmw_conten_no_revamp: "edelmw-content-uat/content/",
    appIdKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOjEsImZmIjoiVyIsImJkIjoid2ViLXBjIiwibmJmIjoxNjQ2MjAzNTAzLCJzcmMiOiJlbXRtdyIsImF2IjoiMS4wLjAuNCIsImFwcGlkIjoiNjYzMDUxY2ZiYWM3ZDY5OWExYzU5Yjk2MDQ4YjUwZTciLCJpc3MiOiJlbXQiLCJleHAiOjE2NDYyNDU4MDAsImlhdCI6MTY0NjIwMzgwM30.VCTEFN-PGmGoxUpUElRskqXEkqlvtJ43CbdUlCX1HmQ",
};
const cug = {
    rootUrl: "https://vamacug.nuvamawealth.com/",
    web_mw: "https://ewmw.edelweiss.in/ewmwcug/api/",
    streamUrl: "wss://nwst.nuvamawealth.com/",
    jmwedel: "https://tx3.edelweiss.in/",
    jmw: "https://nmwcug.nuvamawealth.com/",
    jmw_reports: "https://nmwcug.nuvamawealth.com/",
    jmw_content: "edelmw-content-cug/content/",
    jmw_news_content: "edelmw-spr-content-cug/",
    jmw_login: "edelmw-login-cug/login/",
    adminuat: "https://nmwcug.nuvamawealth.com/",
    appId: "4fe68b7536784e3407c3ecf19be7c4ad",
    oldWebUrl: "https://vamacug.nuvamawealth.com/",
    newWebUrl: "https://vamacug.nuvamawealth.com/cug/alpha/bucket1",
    edisUrl: "https://vamacug.nuvamawealth.com/edis",
    epledgeUrl: "https://vamacug.nuvamawealth.com/epledge",
    unpledgeurl: "https://vamacug.nuvamawealth.com/epledge/?unpledge",
    reportBase: "cug/",
    baseEnvironment: "cug/",
    feReportBase: "/reports",
    revamp: "",
    jmw_content_kambala: "edelmw-content-cug-revamp/content/",
    eqedel: "edelmw-eq-cug/eq/",
    commedel: "edelmw-comm-cug/comm/",
    equity: "edelmw-eq-cug/eq/",
    commodity: "edelmw-comm-cug/comm/",
    accOpeningUrl: "https://onboarding.nuvamawealth.com/",
    kambalaBase: "",
    kambalaSwitch: true,
    web_config_access_reports: "new-features/",
    jmw_market: "",
    jmw_mf: "",
    jmw_eq: "",
    appClient: "",
    jmw_market_env: "",
    edelmw_sr: "",
    edelmw_nse: "",
    jmw_conten_no_revamp: "edelmw-content-cug/content/",
    appIdKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOjEsImZmIjoiVyIsImJkIjoid2ViLXBjIiwibmJmIjoxNTc5MjQxODMyLCJzcmMiOiJlbXRtdyIsImF2IjoiMS4wLjAuNCIsImFwcGlkIjoiNGZlNjhiNzUzNjc4NGUzNDA3YzNlY2YxOWJlN2M0YWQiLCJpc3MiOiJlbXQiLCJleHAiOjE2MTA3NzgxMzIsImlhdCI6MTU3OTI0MjEzMn0.IR-PKf1Jjr69bsERFmMeuZrZ2RafBDiTGgKA6Ygofdo",
};
const prod = {
    rootUrl: "https://www.nuvamawealth.com/",
    web_mw: "https://nwmw.nuvamawealth.com/api/",
    streamUrl: "wss://nwst.nuvamawealth.com",
    jmwedel: "https://emt.edelweiss.in/",
    jmw: "https://nw.nuvamawealth.com/",
    jmw_reports: "https://nw.nuvamawealth.com/",
    jmw_content: "edelmw-content/content/",
    jmw_news_content: "edelmw-spr-content/",
    jmw_login: "edelmw-login/login/",
    adminuat: "https://nw.nuvamawealth.com/",
    appId: "4fe68b7536784e3407c3ecf19be7c4ad",
    oldWebUrl: "https://www.nuvamawealth.com/",
    newWebUrl: "https://www.nuvamawealth.com",
    edisUrl: "https://www.nuvamawealth.com/edis",
    epledgeUrl: "https://www.nuvamawealth.com/epledge",
    unpledgeurl: "https://www.nuvamawealth.com/epledge/?unpledge",
    reportBase: "",
    baseEnvironment: "",
    feReportBase: "/reports",
    revamp: "",
    jmw_content_kambala: "edelmw-content/content/content/",
    eqedel: "edelmw-eq/eq/",
    commedel: "edelmw-comm/comm/",
    equity: "edelmw-eq/eq/",
    commodity: "edelmw-comm/comm/",
    accOpeningUrl: "https://onboarding.nuvamawealth.com/",
    kambalaBase: "devserver/",
    kambalaSwitch: true,
    web_config_access_reports: "new-features/",
    appClient: "app-client/",
    jmw_market: "app-marketstats/",
    jmw_mf: "edelmw-mf/mf/",
    jmw_eq: "edelmw-eq/eq/",
    appIdKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOjEsImZmIjoiVyIsImJkIjoid2ViLXBjIiwibmJmIjoxNTc5MjQxODMyLCJzcmMiOiJlbXRtdyIsImF2IjoiMS4wLjAuNCIsImFwcGlkIjoiNGZlNjhiNzUzNjc4NGUzNDA3YzNlY2YxOWJlN2M0YWQiLCJpc3MiOiJlbXQiLCJleHAiOjE2MTA3NzgxMzIsImlhdCI6MTU3OTI0MjEzMn0.IR-PKf1Jjr69bsERFmMeuZrZ2RafBDiTGgKA6Ygofdo",
    jmw_market_env: "",
    edelmw_sr: "edelmw-sr",
    edelmw_nse: "edelmw-nse/nse/",
    jmw_conten_no_revamp: "",
};
export const config = process.env.NODE_ENV === "production"
    ? prod
    : process.env.NODE_ENV === "cug"
        ? cug
        : process.env.NODE_ENV === "uat"
            ? uat
            : dev;
export default config;
